export const GET_NEWS = 'GET_NEWS';
export const GET_AREAS = 'GET_AREAS';
export const PREVIEW = 'PREVIEW';
export const SET_BODY = 'SET_BODY';
export const GET_BANNER = 'GET_BANNER';
export const AGREGAR = 'AGREGAR';
export const FILTRAR = 'FILTRAR';